import Vue from "vue";
import Vuex from "vuex";
import { isProduction } from "@/utils";

Vue.use(Vuex);

export default new Vuex.Store({
    strict: !isProduction
});
